// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../imgs/bluesky.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../imgs/share-all.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
  with slight edits made by Me!
*/
:root {
    --shadow: rgba(38, 11, 54, 0.534);
    --default: rgb(49, 53, 78);
    --icon-color: rgb(175, 29, 102);
}
*, *::before, *::after {
    box-sizing: border-box;
}
*:not(dialog) {
    margin: 0;
}
body {
    line-height: calc(1em + 0.5rem);
    -webkit-font-smoothing: antialiased;
    min-height: 100vh;
}
img {
    max-width: 100%;
    font-style: italic;
    background-repeat: no-repeat;
    background-size: cover;
    height: auto;
    vertical-align: middle;
    shape-margin: 1rem;

}
input, button, textarea, select {
    font: inherit;
}
p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
}
p {
    text-wrap: pretty;
}
h1, h2, h3, h4, h5, h6 {
    text-wrap: balance;
}
ul, li, section, main, header, footer {
    padding: 0;
    margin: 0;
}
li {
    list-style: none;
}
a {
    text-decoration: none;
}

i {
    font-size: 2rem;
    color: var(--icon-color);
}
div[class~="icon"] {
    --icon-size: 2rem;
    width: var(--icon-size);
    height: var(--icon-size);
    background-color: var(--icon-color);
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    mask-size: var(--icon-size);
}
div[class="share"] {
    --icon-size: 2rem;
    width: var(--icon-size);
    height: var(--icon-size);
    background-color: var(--icon-color);
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
    mask-size: var(--icon-size);
}
body {
    display: grid;
    gap: 1rem;
    grid-template-rows: 0.5fr 1fr 0.5fr;
    max-width: 100vw;
    min-height: 150vh;
}

header {
    padding: 2rem;
    display: flex;
    justify-content: center;
    position: relative;
    overflow: hidden;
    align-items: center;
}
h1 {
        position: absolute;
        position-anchor: --about-me-pic;
        z-index: 1;
        bottom: anchor(bottom);
        left: anchor(left);
        padding: 1rem;
        font-size: 28px;
        font-weight: 700;
        color: white;
    }
div.about-me {
        flex: 0 1 1;
        background: white;
        box-shadow: var(--shadow) 0px 5px 4px;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 2rem;
        max-width: 120ch;
        max-height: 420px;
    }

section.header-area {
    display: flex;
    justify-content: center;
    align-items: center;
    }
.example {
    anchor-name: --about-me-pic;
    position: relative;
    flex: 0 0 1;
    background: rgb(169, 193, 238);
    min-width: 400px;
    aspect-ratio: 1;
    align-content: center;
    text-align: center;
    box-shadow: var(--shadow) 0px 5px 4px;
}
.icon-area {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
}

div.background {
    min-width: 4000px;
    min-height: 35vh;
    position: absolute;
    top: -200px;
    left: -100px;
    transform: rotate(-5deg);
    background: var(--default);
    z-index: -1;
}

main {
    --project-size: 380px;
    padding: 2rem;
    display: flex;
    flex-direction: column;

    gap: 1rem;

    .card-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 2rem;
        justify-content: center;

        section.card {
            width: var(--project-size);
            height: var(--project-size);
            box-shadow: var(--shadow) 0px 5px 4px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }
    }
    .share-area, .title-area {
        display: flex;
        gap: 1rem;
        justify-content: space-between;
        align-items: center;
    }
    .project-area {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1rem;
        background: white;
        width: var(--project-size);
        height: 50%;
        overflow: hidden;
    }
}

footer {
    max-width: 100vw;
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    background: var(--default);
    min-height: 60dvh;
    padding: 2rem;
    place-self: stretch;
    color: white;
}

.footer-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    justify-content: space-between;
    align-items: flex-start;
}
.footer-wrapper > p {
    max-width: 70ch;
}
.footer-wrapper > * {
    padding-left: 2rem;
}
footer > .image {
    background: rgb(169, 193, 238);
    width: 450px;
    height: 450px;
    align-content: center;
    text-align: center;
}

main > h2, footer > h2 {
    padding-left: 2rem;
}


@media (max-width: 980px) {
    body {
        display: flex;
        flex-direction: column;
    }
    header {
        align-items: flex-start;
    }
    section.header-area {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        align-items: center;
        justify-items: center;
    }
    div.about-me {
        display: flex;
        padding-top: 3rem;
        justify-content: flex-end;
        flex-wrap: nowrap;
        gap: 2rem;
        grid-column: 1 / -1;
        grid-row: 2;
        max-height: 400px;
    }
    div.example {
        grid-row: 1;
        place-self: start;
        margin-top: -20px;
        margin-left: -20px;
        height: 350px;
        min-width: 300px;
        grid-column: 3;
    }
}

@media (max-width: 630px) {
    section.header-area {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0;
        margin: 0;
    }
    div.example {
        place-self: center;
        margin: 0;
        height: 500px;
        min-width: 350px;
        aspect-ratio: 0;
    }
    div.about-me {
        justify-items: center;
        min-height: fit-content;
        min-width: 400px;
        box-shadow: none;
        
    }
}

@media (max-width: 380px) {
    main {
        --project-size: 280px;
        .card-wrapper {
            display: flex;
            flex-wrap: wrap;
            gap: 2rem;
            justify-content: center;

                section.card {
                    min-width: var(--project-size);
                    min-height: var(--project-size);
                    box-shadow: var(--shadow) 0px 5px 4px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
            }
        }
    }
    .about-me > * {
        padding: 1rem;
    }
    footer > * , footer > h2, main > h2 {
        padding-left: 0.2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,+BAA+B;AACnC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,SAAS;AACb;AACA;IACI,+BAA+B;IAC/B,mCAAmC;IACnC,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;;AAEtB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,mCAAmC;IACnC,8DAAmD;IACnD,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,mCAAmC;IACnC,8DAAqD;IACrD,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;QACQ,kBAAkB;QAClB,+BAA+B;QAC/B,UAAU;QACV,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;AACJ;QACQ,WAAW;QACX,iBAAiB;QACjB,qCAAqC;QACrC,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,aAAa;QACb,gBAAgB;QAChB,iBAAiB;IACrB;;AAEJ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,aAAa;IACb,sBAAsB;;IAEtB,SAAS;;IAET;QACI,aAAa;QACb,eAAe;QACf,SAAS;QACT,uBAAuB;;QAEvB;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,qCAAqC;YACrC,aAAa;YACb,sBAAsB;YACtB,yBAAyB;QAC7B;IACJ;IACA;QACI,aAAa;QACb,SAAS;QACT,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,aAAa;QACb,iBAAiB;QACjB,0BAA0B;QAC1B,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,qCAAqC;QACrC,mBAAmB;QACnB,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,iBAAiB;QACjB,yBAAyB;QACzB,iBAAiB;QACjB,SAAS;QACT,mBAAmB;QACnB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,UAAU;QACV,SAAS;IACb;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,aAAa;QACb,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;;IAEpB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;YACI,aAAa;YACb,eAAe;YACf,SAAS;YACT,uBAAuB;;gBAEnB;oBACI,8BAA8B;oBAC9B,+BAA+B;oBAC/B,qCAAqC;oBACrC,aAAa;oBACb,sBAAsB;oBACtB,yBAAyB;YACjC;QACJ;IACJ;IACA;QACI,aAAa;IACjB;IACA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/*\n  Josh's Custom CSS Reset\n  https://www.joshwcomeau.com/css/custom-css-reset/\n  with slight edits made by Me!\n*/\n:root {\n    --shadow: rgba(38, 11, 54, 0.534);\n    --default: rgb(49, 53, 78);\n    --icon-color: rgb(175, 29, 102);\n}\n*, *::before, *::after {\n    box-sizing: border-box;\n}\n*:not(dialog) {\n    margin: 0;\n}\nbody {\n    line-height: calc(1em + 0.5rem);\n    -webkit-font-smoothing: antialiased;\n    min-height: 100vh;\n}\nimg {\n    max-width: 100%;\n    font-style: italic;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: auto;\n    vertical-align: middle;\n    shape-margin: 1rem;\n\n}\ninput, button, textarea, select {\n    font: inherit;\n}\np, h1, h2, h3, h4, h5, h6 {\n    overflow-wrap: break-word;\n}\np {\n    text-wrap: pretty;\n}\nh1, h2, h3, h4, h5, h6 {\n    text-wrap: balance;\n}\nul, li, section, main, header, footer {\n    padding: 0;\n    margin: 0;\n}\nli {\n    list-style: none;\n}\na {\n    text-decoration: none;\n}\n\ni {\n    font-size: 2rem;\n    color: var(--icon-color);\n}\ndiv[class~=\"icon\"] {\n    --icon-size: 2rem;\n    width: var(--icon-size);\n    height: var(--icon-size);\n    background-color: var(--icon-color);\n    mask: url(\"./../imgs/bluesky.svg\") no-repeat center;\n    mask-size: var(--icon-size);\n}\ndiv[class=\"share\"] {\n    --icon-size: 2rem;\n    width: var(--icon-size);\n    height: var(--icon-size);\n    background-color: var(--icon-color);\n    mask: url(\"./../imgs/share-all.svg\") no-repeat center;\n    mask-size: var(--icon-size);\n}\nbody {\n    display: grid;\n    gap: 1rem;\n    grid-template-rows: 0.5fr 1fr 0.5fr;\n    max-width: 100vw;\n    min-height: 150vh;\n}\n\nheader {\n    padding: 2rem;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n    align-items: center;\n}\nh1 {\n        position: absolute;\n        position-anchor: --about-me-pic;\n        z-index: 1;\n        bottom: anchor(bottom);\n        left: anchor(left);\n        padding: 1rem;\n        font-size: 28px;\n        font-weight: 700;\n        color: white;\n    }\ndiv.about-me {\n        flex: 0 1 1;\n        background: white;\n        box-shadow: var(--shadow) 0px 5px 4px;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 2rem;\n        max-width: 120ch;\n        max-height: 420px;\n    }\n\nsection.header-area {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    }\n.example {\n    anchor-name: --about-me-pic;\n    position: relative;\n    flex: 0 0 1;\n    background: rgb(169, 193, 238);\n    min-width: 400px;\n    aspect-ratio: 1;\n    align-content: center;\n    text-align: center;\n    box-shadow: var(--shadow) 0px 5px 4px;\n}\n.icon-area {\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n}\n\ndiv.background {\n    min-width: 4000px;\n    min-height: 35vh;\n    position: absolute;\n    top: -200px;\n    left: -100px;\n    transform: rotate(-5deg);\n    background: var(--default);\n    z-index: -1;\n}\n\nmain {\n    --project-size: 380px;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n\n    gap: 1rem;\n\n    .card-wrapper {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 2rem;\n        justify-content: center;\n\n        section.card {\n            width: var(--project-size);\n            height: var(--project-size);\n            box-shadow: var(--shadow) 0px 5px 4px;\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-end;\n        }\n    }\n    .share-area, .title-area {\n        display: flex;\n        gap: 1rem;\n        justify-content: space-between;\n        align-items: center;\n    }\n    .project-area {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 1rem;\n        background: white;\n        width: var(--project-size);\n        height: 50%;\n        overflow: hidden;\n    }\n}\n\nfooter {\n    max-width: 100vw;\n    display: flex;\n    gap: 2rem;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    align-items: center;\n    background: var(--default);\n    min-height: 60dvh;\n    padding: 2rem;\n    place-self: stretch;\n    color: white;\n}\n\n.footer-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n.footer-wrapper > p {\n    max-width: 70ch;\n}\n.footer-wrapper > * {\n    padding-left: 2rem;\n}\nfooter > .image {\n    background: rgb(169, 193, 238);\n    width: 450px;\n    height: 450px;\n    align-content: center;\n    text-align: center;\n}\n\nmain > h2, footer > h2 {\n    padding-left: 2rem;\n}\n\n\n@media (max-width: 980px) {\n    body {\n        display: flex;\n        flex-direction: column;\n    }\n    header {\n        align-items: flex-start;\n    }\n    section.header-area {\n        display: grid;\n        grid-template-columns: repeat(6, 1fr);\n        align-items: center;\n        justify-items: center;\n    }\n    div.about-me {\n        display: flex;\n        padding-top: 3rem;\n        justify-content: flex-end;\n        flex-wrap: nowrap;\n        gap: 2rem;\n        grid-column: 1 / -1;\n        grid-row: 2;\n        max-height: 400px;\n    }\n    div.example {\n        grid-row: 1;\n        place-self: start;\n        margin-top: -20px;\n        margin-left: -20px;\n        height: 350px;\n        min-width: 300px;\n        grid-column: 3;\n    }\n}\n\n@media (max-width: 630px) {\n    section.header-area {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 0;\n        margin: 0;\n    }\n    div.example {\n        place-self: center;\n        margin: 0;\n        height: 500px;\n        min-width: 350px;\n        aspect-ratio: 0;\n    }\n    div.about-me {\n        justify-items: center;\n        min-height: fit-content;\n        min-width: 400px;\n        box-shadow: none;\n        \n    }\n}\n\n@media (max-width: 380px) {\n    main {\n        --project-size: 280px;\n        .card-wrapper {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 2rem;\n            justify-content: center;\n\n                section.card {\n                    min-width: var(--project-size);\n                    min-height: var(--project-size);\n                    box-shadow: var(--shadow) 0px 5px 4px;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: flex-end;\n            }\n        }\n    }\n    .about-me > * {\n        padding: 1rem;\n    }\n    footer > * , footer > h2, main > h2 {\n        padding-left: 0.2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
